import React, { useState } from "react";
import { CalendarCheck, Copy, X } from "lucide-react";
import { toast } from "sonner";

const FEED = `${process.env.REACT_APP_BACKEND_URL}/api/rides/calendar.ics`;
const WEBCAL = FEED.replace(/^https?:\/\//, "webcal://");
const GOOGLE = `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(WEBCAL)}`;

// One link that keeps every club ride in a rider's own calendar.
export default function CalendarSubscribe() {
  const [open, setOpen] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(FEED);
      toast("Calendar link copied");
    } catch {
      toast.error("Couldn't copy — long-press the link instead");
    }
  }

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-brand-accent border border-brand-accent/40 rounded-full px-2.5 py-1 active:scale-95"
        data-testid="calendar-subscribe-button"
      >
        <CalendarCheck className="w-3.5 h-3.5" /> Subscribe
      </button>

      {open && (
        <div className="fixed inset-0 z-[70] bg-black/60 flex items-end sm:items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="calendar-subscribe-modal">
          <div className="w-full max-w-sm bg-bg-primary rounded-2xl p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-[10px] font-mono-stat uppercase tracking-widest text-text-muted">Club calendar</div>
                <h3 className="font-heading text-2xl font-black uppercase leading-tight">Every ride, automatically</h3>
                <p className="text-xs text-text-secondary mt-1">Subscribe once — new rides, date changes and cancellations update in your calendar on their own.</p>
              </div>
              <button onClick={() => setOpen(false)} className="p-1 text-text-muted" aria-label="Close" data-testid="calendar-subscribe-close">
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="mt-4 space-y-2">
              <a
                href={WEBCAL}
                className="w-full flex items-center justify-center gap-2 rounded-xl bg-text-primary text-bg-primary uppercase tracking-widest text-[11px] font-black py-3 active:scale-[0.98]"
                data-testid="calendar-subscribe-apple"
              >
                Apple / iPhone / Outlook
              </a>
              <a
                href={GOOGLE}
                target="_blank"
                rel="noreferrer"
                className="w-full flex items-center justify-center gap-2 rounded-xl border border-border-subtle bg-bg-secondary text-text-primary uppercase tracking-widest text-[11px] font-bold py-3 active:scale-[0.98]"
                data-testid="calendar-subscribe-google"
              >
                Google Calendar
              </a>
              <button
                onClick={copy}
                className="w-full flex items-center justify-center gap-2 rounded-xl border border-border-subtle bg-bg-secondary text-text-secondary uppercase tracking-widest text-[11px] font-bold py-3 active:scale-[0.98]"
                data-testid="calendar-subscribe-copy"
              >
                <Copy className="w-3.5 h-3.5" /> Copy link
              </button>
              <div className="text-[10px] text-text-muted break-all font-mono-stat" data-testid="calendar-subscribe-url">{FEED}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
